import React from 'react';
import { Grid } from '@mui/material';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { TransactionsTableCompsProps } from './GpcTableComps.props';

const TransactionsTableComps = ({ GPCDataGrid, onCellsChanged }: TransactionsTableCompsProps) => (
  <Grid item xs={6} style={{ marginTop: '2rem' }}>
    <ScalarDatasheet
      className="comp-datasheet transactions-table-comps"
      data={GPCDataGrid}
      onCellsChanged={onCellsChanged}
    />
  </Grid>
);

export default TransactionsTableComps;
